import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";

const HousekeepingV4Response = z.object({
    id: z.nullable(z.string()),
    date_housekeeping: z.nullable(z.string()),
    room_condition: z.nullable(z.string()),
    room_status: z.string(),
    comment: z.nullable(z.string()),
    property_id: z.string(),
    property_name: z.string(),
    room_type_id: z.string(),
    room_type_name: z.string(),
    room_id: z.string(),
    room_number: z.string(),
    staff_name: z.nullable(z.string()),
    arrival_date: z.nullable(z.string()),
    departure_date: z.nullable(z.string()),
    checkin_today: z.boolean(),
    frontdesk_status: z.nullable(z.string()),
});

export const HousekeepingV4ResponseSchema = BaseResponseSchema(z.array(HousekeepingV4Response));
export type HousekeepingV4ResponseSchemaType = z.infer<typeof HousekeepingV4ResponseSchema>;
export type HousekeepingV4ResponseType = z.infer<typeof HousekeepingV4Response>;
export { HousekeepingV4Response };
export const SingleHousekeepingV4ResponseSchema = BaseResponseSchema(HousekeepingV4Response);